export function formatRwf(amount: number): string {
  return `RWF ${amount.toLocaleString('en-US')}`
}
